import { render, staticRenderFns } from "./shebeiAuthCtcc.vue?vue&type=template&id=3019b234&scoped=true&"
import script from "./shebeiAuthCtcc.vue?vue&type=script&lang=js&"
export * from "./shebeiAuthCtcc.vue?vue&type=script&lang=js&"
import style0 from "./shebeiAuthCtcc.vue?vue&type=style&index=0&id=3019b234&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3019b234",
  null
  
)

export default component.exports